
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { database } from '../../Firebase';
import { ref, push, set } from 'firebase/database';

const Newmilakhatregister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state?.record;
  const [formData, setFormData] = useState({
    propertyNo: '',
    mainOwner: '',
    mainOwnerWife: '',
    wardName: 'नाही',
    divisionType: 'गावठाण',
    roadName: '',
    citySurveyNo: '',
    multipleOwners: false,
    occupant: false,
  });

  const [showMultipleOwnersForm, setShowMultipleOwnersForm] = useState(false);
  const [showOccupantForm, setShowOccupantForm] = useState(false);
  const [multipleOwnersData, setMultipleOwnersData] = useState([]);
  const [occupantData, setOccupantData] = useState([]);
  const [currentOwnerData, setCurrentOwnerData] = useState({
    name: '',
    mobileNumber: '',
    aadharNumber: ''
  });
  const [currentOccupantData, setCurrentOccupantData] = useState({
    name: '',
    mobileNumber: '',
    aadharNumber: ''
  });

  const [taxData, setTaxData] = useState({
    houseTax: { previous: 0, current: 0, total: 0 },
    electricityTax: { previous: 0, current: 0, total: 0 },
    healthTax: { previous: 0, current: 0, total: 0 },
    total: { previous: 0, current: 0, total: 0 },
  });

  // मिळकत सविस्तर माहिती state
  const [propertyDetailData, setPropertyDetailData] = useState({
    propertyType: 'दगड विटा मातीची इमारत',
    length: '',
    width: '',
    area: '0',
    areaDiscount: '0',
    areaSqKm: '0',
    capitalValue: '0',
    usageType: 'निवासी',
    constructionDate: '01/04/2025',
    readyReckonerType: 'अर्धे पक्के',
    electricityTax: true,
    electricityTaxDiscount: '0',
    healthTax: true,
    healthTaxDiscount: '0',
    propertyDescription: '',
    propertyDescriptionAsAbove: false,
  });

  const [propertyRecords, setPropertyRecords] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  // Populate data if in edit mode
  useEffect(() => {
    if (editData) {
      setFormData({
        propertyNo: editData.propertyNo || '',
        mainOwner: editData.mainOwner || '',
        mainOwnerWife: editData.mainOwnerWife || '',
        wardName: editData.wardName || 'नाही',
        divisionType: editData.divisionType || 'गावठाण',
        roadName: editData.roadName || '',
        citySurveyNo: editData.citySurveyNo || '',
        multipleOwners: editData.multipleOwners || false,
        occupant: editData.occupant || false,
      });

      if (editData.owners) {
        setMultipleOwnersData(editData.owners);
        setShowMultipleOwnersForm(editData.multipleOwners);
      }
      
      if (editData.occupants) {
        setOccupantData(editData.occupants);
        setShowOccupantForm(editData.occupant);
      }

      if (editData.taxData) {
        setTaxData(editData.taxData);
      }

      if (editData.propertyRecords) {
        setPropertyRecords(editData.propertyRecords);
      }
    }
  }, [editData]);

  // Auto-calculate Total Taxes whenever propertyRecords changes
  React.useEffect(() => {
    const totalHouseTax = propertyRecords.reduce((sum, record) => sum + (record.houseTax || 0), 0);
    const totalElectricityTax = propertyRecords.reduce((sum, record) => sum + (record.electricityTaxVal || 0), 0);
    const totalHealthTax = propertyRecords.reduce((sum, record) => sum + (record.healthTaxVal || 0), 0);

    setTaxData(prev => ({
      ...prev,
      houseTax: { ...prev.houseTax, current: totalHouseTax, total: prev.houseTax.previous + totalHouseTax },
      electricityTax: { ...prev.electricityTax, current: totalElectricityTax, total: prev.electricityTax.previous + totalElectricityTax },
      healthTax: { ...prev.healthTax, current: totalHealthTax, total: prev.healthTax.previous + totalHealthTax },
      total: { 
        ...prev.total, 
        current: totalHouseTax + totalElectricityTax + totalHealthTax,
        total: prev.total.previous + (totalHouseTax + totalElectricityTax + totalHealthTax)
      }
    }));
  }, [propertyRecords]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === 'multipleOwners') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
      setShowMultipleOwnersForm(checked);
    } else if (name === 'occupant') {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
      setShowOccupantForm(checked);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }
  };

  const handleTaxChange = (e, taxType, period) => {
    const { value } = e.target;
    setTaxData((prevData) => {
      const newTaxData = {
        ...prevData,
        [taxType]: {
          ...prevData[taxType],
          [period]: parseFloat(value) || 0,
        },
      };

      newTaxData[taxType].total = newTaxData[taxType].previous + newTaxData[taxType].current;

      newTaxData.total.previous = newTaxData.houseTax.previous + newTaxData.electricityTax.previous + newTaxData.healthTax.previous;
      newTaxData.total.current = newTaxData.houseTax.current + newTaxData.electricityTax.current + newTaxData.healthTax.current;
      newTaxData.total.total = newTaxData.houseTax.total + newTaxData.electricityTax.total + newTaxData.healthTax.total;

      return newTaxData;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.propertyNo) {
        alert('कृपया मिळकत क्रमांक प्रविष्ट करा');
        return;
    }

    const allOwnersData = multipleOwnersData.filter(owner => owner.name.trim() !== '');
    const allOccupantsData = occupantData.filter(occupant => occupant.name.trim() !== '');
    
    const recordData = {
        ...formData,
        owners: allOwnersData,
        occupants: allOccupantsData,
        taxData: taxData,
        propertyRecords: propertyRecords,
        timestamp: new Date().toISOString(),
    };

    // Construct path using Property Number
    const recordPath = `Grampanchayat/Gramniddhi/NewMilakhatRecords/${formData.propertyNo}`;
    const recordRef = ref(database, recordPath);
    
    set(recordRef, recordData)
      .then(() => {
        alert(editData ? 'मिळकत माहिती यशस्वीरित्या अद्ययावत केली गेली!' : 'मिळकत माहिती यशस्वीरित्या जतन केली गेली!');
        navigate('/milakhatnondani'); 
      })
      .catch((error) => {
        console.error("Error saving data: ", error);
        alert('माहिती जतन करण्यात त्रुटी आली. कृपया पुन्हा प्रयत्न करा.');
      });
  };

  const handleBack = () => {
    navigate('/milakhatnondani');
  };

  const handleMultipleOwnerChange = (id, field, value) => {
    setMultipleOwnersData(prevData => 
      prevData.map(owner => 
        owner.id === id ? { ...owner, [field]: value } : owner
      )
    );
  };

  const handleCurrentOwnerChange = (e) => {
    const { name, value } = e.target;
    setCurrentOwnerData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const openDetailModal = (record) => {
    setSelectedRecord(record);
    setShowDetailModal(true);
  };

  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedRecord(null);
  };

  const addOwner = () => {
    // Validate current owner data
    if (!currentOwnerData.name.trim()) {
      alert('कृपया मालकाचे नाव प्रविष्ट करा');
      return;
    }

    const newId = multipleOwnersData.length > 0 ? Math.max(...multipleOwnersData.map(o => o.id)) + 1 : 1;
    const newOwner = {
      id: newId,
      name: currentOwnerData.name,
      mobileNumber: currentOwnerData.mobileNumber,
      aadharNumber: currentOwnerData.aadharNumber
    };

    setMultipleOwnersData(prevData => [...prevData, newOwner]);
    
    // Reset current form
    setCurrentOwnerData({
      name: '',
      mobileNumber: '',
      aadharNumber: ''
    });
  };

  const removeOwner = (id) => {
    setMultipleOwnersData(multipleOwnersData.filter(owner => owner.id !== id));
  };

  const handleCurrentOccupantChange = (e) => {
    const { name, value } = e.target;
    setCurrentOccupantData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const addOccupant = () => {
    // Validate current occupant data
    if (!currentOccupantData.name.trim()) {
      alert('कृपया भोगवाटधारकाचे नाव प्रविष्ट करा');
      return;
    }

    const newId = occupantData.length > 0 ? Math.max(...occupantData.map(o => o.id)) + 1 : 1;
    const newOccupant = {
      id: newId,
      name: currentOccupantData.name,
      mobileNumber: currentOccupantData.mobileNumber,
      aadharNumber: currentOccupantData.aadharNumber
    };

    setOccupantData(prevData => [...prevData, newOccupant]);
    
    // Reset current form
    setCurrentOccupantData({
      name: '',
      mobileNumber: '',
      aadharNumber: ''
    });
  };

  const removeOccupant = (id) => {
    setOccupantData(occupantData.filter(occupant => occupant.id !== id));
  };

  const closeOccupantForm = () => {
    setShowOccupantForm(false);
    setFormData(prevData => ({
      ...prevData,
      occupant: false,
    }));
  };

  const getFilteredOccupants = () => {
    return occupantData.filter(occupant => occupant.name.trim() !== '');
  };

  const closeMultipleOwnersForm = () => {
    setShowMultipleOwnersForm(false);
    setFormData(prevData => ({
      ...prevData,
      multipleOwners: false,
    }));
  };

  const getFilteredOwners = () => {
    return multipleOwnersData.filter(owner => owner.name.trim() !== '');
  };

  // मिळकत सविस्तर माहिती handlers
  // मिळकत सविस्तर माहिती handlers
  const handlePropertyDetailChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setPropertyDetailData((prevData) => {
      const newState = {
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      };

      // Auto-calculate Area (Sq. Ft.) = Length * Width
      if (name === 'length' || name === 'width') {
          const l = parseFloat(newState.length) || 0;
          const w = parseFloat(newState.width) || 0;
          newState.area = (l * w).toFixed(2);
      }

      // Auto-select Ready Reckoner Type based on Property Type
      if (name === 'propertyType') {
         const typeMapping = {
             'झोपडी मातीचे घर': 'कच्चे',
             'दगड विटा मातीची इमारत': 'अर्धे पक्के',
             'दगड विट सिंमेट घर / लोड बेँअरींग': 'इतर पक्के',
             'आर सी सी इमारत': 'आर.सी.सी.',
             'बखळ जागा': 'जमिन'
         };
         if (typeMapping[value]) {
             newState.readyReckonerType = typeMapping[value];
         }
      }

      // Calculation Logic
      let { area } = newState;
      
      // Auto-calculate Area Sq Meter (1 sq ft = 0.092903 sq m)
      if (name === 'area' || name === 'length' || name === 'width' || name === 'propertyType') {
          const areaSqFt = parseFloat(area) || 0;
          const areaSqM = (areaSqFt * 0.0929).toFixed(1);
          newState.areaSqKm = areaSqM; // Using areaSqKm variable name for Sq Meter as per existing code structure

          // Capital Value Calculation
          // Rates (Assumed hardcoded as per image ex for now)
          const landRate = 1760;
          const constructionRate = 12443;
          const depreciation = 1;
          const usageFactor = 1; 

          const capitalVal = ((parseFloat(areaSqM) * landRate) + (parseFloat(areaSqM) * constructionRate * depreciation)) * usageFactor;
          newState.capitalValue = Math.round(capitalVal).toString();
      }

      // Auto-populate Property Description if 'Same as above' is checked
      if (newState.propertyDescriptionAsAbove) {
         newState.propertyDescription = `${newState.propertyType}, लांबी: ${newState.length}, रुंदी: ${newState.width}, क्षेत्रफळ: ${newState.area}, सुट: ${newState.areaDiscount}, स्के.मी.: ${newState.areaSqKm}, भांडवली मुल्य: ${newState.capitalValue}, वापर: ${newState.usageType}, बांधकाम: ${newState.constructionDate}, रेडीरेकनर: ${newState.readyReckonerType}`;
      } else if (name === 'propertyDescriptionAsAbove' && !checked) {        
         // Optional: Clear or keep description when unchecked? 
         // Usually keeping it is better user experience so they can edit it.
      }

      return newState;
    });
  };

  const handleAddPropertyToList = () => {
    // Calculate Taxes for the record
    const capitalVal = parseFloat(propertyDetailData.capitalValue) || 0;
    const houseTaxRate = 0.6;
    const houseTax = Math.round((capitalVal * houseTaxRate) / 1000);
    
    // Fixed taxes for now as per image or simple logic
    const electricityTaxVal = propertyDetailData.electricityTax ? 50 : 0;
    const healthTaxVal = propertyDetailData.healthTax ? 50 : 0;

    const newRecord = {
      id: Date.now(),
      propertyType: propertyDetailData.propertyType,
      area: propertyDetailData.area,
      areaDiscount: propertyDetailData.areaDiscount,
      areaSqKm: propertyDetailData.areaSqKm, // This holds Sq Meter value
      capitalValue: propertyDetailData.capitalValue,
      usageType: propertyDetailData.usageType,
      constructionDate: propertyDetailData.constructionDate,
      readyReckonerType: propertyDetailData.readyReckonerType,
      electricityTax: propertyDetailData.electricityTax,
      electricityTaxDiscount: propertyDetailData.electricityTaxDiscount,
      electricityTaxVal: electricityTaxVal,
      healthTax: propertyDetailData.healthTax,
      healthTaxDiscount: propertyDetailData.healthTaxDiscount,
      healthTaxVal: healthTaxVal,
      houseTax: houseTax,
      propertyDescription: propertyDetailData.propertyDescriptionAsAbove ? generatePropertyDescription() : propertyDetailData.propertyDescription,
    };
    
    setPropertyRecords([...propertyRecords, newRecord]);

    // Reset Form Fields for next entry
    setPropertyDetailData(prev => ({
      ...prev,
      length: '',
      width: '',
      area: '0',
      areaDiscount: '0',
      areaSqKm: '0',
      capitalValue: '0',
      electricityTaxDiscount: '0',
      healthTaxDiscount: '0',
      propertyDescription: '',
      propertyDescriptionAsAbove: false,
    }));
  };

  const generatePropertyDescription = () => {
    return `${propertyDetailData.propertyType}, क्षेत्रफळ: ${propertyDetailData.area}, सुट: ${propertyDetailData.areaDiscount}, स्के.मी.: ${propertyDetailData.areaSqKm}, भांडवली मुल्य: ${propertyDetailData.capitalValue}, वापर: ${propertyDetailData.usageType}, बांधकाम: ${propertyDetailData.constructionDate}, रेडीरेकनर: ${propertyDetailData.readyReckonerType}`;
  };

  const handleDeletePropertyRecord = (id) => {
    setPropertyRecords(propertyRecords.filter(record => record.id !== id));
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white p-4 text-xl font-bold flex justify-between items-center">
        <span>{editData ? 'मिळकत माहिती सुधारणा' : 'मिळकत माहिती नोंदणी'}</span>
        <button 
          onClick={handleBack}
          className="bg-white/20 hover:bg-white/30 px-4 py-1 rounded text-sm transition-colors"
        >
          मागे जा
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-4 max-w-7xl mx-auto">
        {/* Main Forms in Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* मिळकत माहिती Section - Left Side (1 column) */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-md p-6 h-full">
              <h2 className="text-lg font-bold mb-4 border-b pb-2">मिळकत माहिती</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* मिळकत क्र. */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    मिळकत क्र.
                  </label>
                  <input
                    type="text"
                    name="propertyNo"
                    value={formData.propertyNo}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                    required
                  />
                </div>

                {/* मुख्य मालक */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    मुख्य मालक
                  </label>
                  <input
                    type="text"
                    name="mainOwner"
                    value={formData.mainOwner}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>

                {/* मुख्य मालकाची पत्नी */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    मुख्य मालकाची पत्नी
                  </label>
                  <input
                    type="text"
                    name="mainOwnerWife"
                    value={formData.mainOwnerWife}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                {/* वार्डचे नाव */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    वार्डचे नाव
                  </label>
                  <select
                    name="wardName"
                    value={formData.wardName}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="नाही">नाही</option>
                    <option value="वार्ड १">वार्ड १</option>
                    <option value="वार्ड २">वार्ड २</option>
                    <option value="वार्ड ३">वार्ड ३</option>
                    <option value="वार्ड ४">वार्ड ४</option>
                    <option value="वार्ड ५">वार्ड ५</option>
                  </select>
                </div>

                {/* विभाग/रेडीरेकनर प्रकार */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    विभाग/रेडीरेकनर प्रकार
                  </label>
                  <select
                    name="divisionType"
                    value={formData.divisionType}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="गावठाण">गावठाण</option>
                    <option value="शहरी">शहरी</option>
                    <option value="औद्योगिक">औद्योगिक</option>
                    <option value="शेती">शेती</option>
                  </select>
                </div>

                {/* रस्ताचे नाव */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    रस्ताचे नाव
                  </label>
                  <input
                    type="text"
                    name="roadName"
                    value={formData.roadName}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                {/* सिटी. सर्व्हे नं. */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    सिटी. सर्व्हे नं.
                  </label>
                  <input
                    type="text"
                    name="citySurveyNo"
                    value={formData.citySurveyNo}
                    onChange={handleChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                {/* Checkboxes */}
                <div className="md:col-span-2 flex items-center space-x-6">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="multipleOwners"
                      checked={formData.multipleOwners}
                      onChange={handleChange}
                      className="mr-2 h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                    />
                    <span className="text-sm text-gray-700">अनेक मिळकतदार</span>
                  </label>

                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="occupant"
                      checked={formData.occupant}
                      onChange={handleChange}
                      className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <span className="text-sm text-gray-700">भोगवाटधारक</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* कर माहिती Section - Right Side (1 column) */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg shadow-md p-6 h-full">
              <h2 className="text-lg font-bold mb-4 border-b pb-2">कर माहिती</h2>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse text-sm">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="border border-gray-300 px-4 py-2 text-left text-sm font-medium text-gray-700">
                        कर प्रकार
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-center text-sm font-medium text-gray-700">
                        मागील
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-center text-sm font-medium text-gray-700">
                        चालू
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-center text-sm font-medium text-gray-700">
                        एकूण
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* घरपट्टी */}
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 text-sm">घरपट्टी</td>
                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          value={taxData.houseTax.previous}
                          onChange={(e) => handleTaxChange(e, 'houseTax', 'previous')}
                          className="w-full px-2 py-1 text-center border border-gray-200 rounded"
                          step="0.01"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          value={taxData.houseTax.current}
                          onChange={(e) => handleTaxChange(e, 'houseTax', 'current')}
                          className="w-full px-2 py-1 text-center border border-gray-200 rounded"
                          step="0.01"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center font-medium">
                        {taxData.houseTax.total.toFixed(2)}
                      </td>
                    </tr>

                    {/* विज कर */}
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 text-sm">विज कर</td>
                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          value={taxData.electricityTax.previous}
                          onChange={(e) => handleTaxChange(e, 'electricityTax', 'previous')}
                          className="w-full px-2 py-1 text-center border border-gray-200 rounded"
                          step="0.01"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          value={taxData.electricityTax.current}
                          onChange={(e) => handleTaxChange(e, 'electricityTax', 'current')}
                          className="w-full px-2 py-1 text-center border border-gray-200 rounded"
                          step="0.01"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center font-medium">
                        {taxData.electricityTax.total.toFixed(2)}
                      </td>
                    </tr>

                    {/* आरोग्य कर */}
                    <tr>
                      <td className="border border-gray-300 px-4 py-2 text-sm">आरोग्य कर</td>
                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          value={taxData.healthTax.previous}
                          onChange={(e) => handleTaxChange(e, 'healthTax', 'previous')}
                          className="w-full px-2 py-1 text-center border border-gray-200 rounded"
                          step="0.01"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <input
                          type="number"
                          value={taxData.healthTax.current}
                          onChange={(e) => handleTaxChange(e, 'healthTax', 'current')}
                          className="w-full px-2 py-1 text-center border border-gray-200 rounded"
                          step="0.01"
                        />
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center font-medium">
                        {taxData.healthTax.total.toFixed(2)}
                      </td>
                    </tr>

                    {/* एकूण */}
                    <tr className="bg-gray-100 font-bold">
                      <td className="border border-gray-300 px-4 py-2 text-sm">एकूण</td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {taxData.total.previous.toFixed(2)}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {taxData.total.current.toFixed(2)}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 text-center">
                        {taxData.total.total.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Forms in Grid Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
          {/* अनेक मिळकतदार फॉर्म - Left Side */}
          {showMultipleOwnersForm && (
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-bold text-primary flex items-center">
                  <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                  </svg>
                  अनेक मिळकतदारांची माहिती
                </h2>
                <button
                  type="button"
                  onClick={closeMultipleOwnersForm}
                  className="px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors duration-200 flex items-center shadow-sm"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  बंद करा
                </button>
              </div>
              
              {/* नया मालक जोड़ने का फॉर्म */}
              <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
                <h3 className="text-md font-semibold text-primary mb-3 flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                  </svg>
                  नवीन मालक जोडा
                </h3>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      मालकाचे नाव *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={currentOwnerData.name}
                      onChange={handleCurrentOwnerChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                      placeholder="मालकाचे पूर्ण नाव"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      मोबाईल नंबर
                    </label>
                    <input
                      type="text"
                      name="mobileNumber"
                      value={currentOwnerData.mobileNumber}
                      onChange={handleCurrentOwnerChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="मोबाईल नंबर"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      आधार कार्ड नंबर
                    </label>
                    <input
                      type="text"
                      name="aadharNumber"
                      value={currentOwnerData.aadharNumber}
                      onChange={handleCurrentOwnerChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="आधार कार्ड नंबर"
                    />
                  </div>
                </div>
                
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    onClick={addOwner}
                    className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center shadow-sm"
                  >
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    मालक जोडा
                  </button>
                </div>
              </div>

              {/* मालकों की सूची - तालिका */}
              <div className="mt-6">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-md font-semibold text-gray-800 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                    </svg>
                    मालकांची यादी
                  </h3>
                  <div className="text-sm text-gray-600">
                    एकूण मालक: <span className="font-bold">{getFilteredOwners().length}</span>
                  </div>
                </div>
                
                {getFilteredOwners().length > 0 ? (
                  <div className="overflow-x-auto border border-gray-300 rounded-lg">
                    <table className="w-full border-collapse text-sm">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            क्रमांक
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            मालकाचे नाव
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            मोबाईल नंबर
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            आधार कार्ड नंबर
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-center text-sm font-medium text-gray-700">
                            क्रिया
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getFilteredOwners().map((owner, index) => (
                          <tr key={owner.id} className="hover:bg-gray-50 even:bg-gray-50">
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {index + 1}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm font-medium">
                              {owner.name}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {owner.mobileNumber || '-'}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {owner.aadharNumber || '-'}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-center">
                              <button
                                type="button"
                                onClick={() => removeOwner(owner.id)}
                                className="px-3 py-1 bg-red-500 text-white text-xs font-medium rounded hover:bg-red-600 transition-colors duration-200 flex items-center mx-auto"
                              >
                                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                हटवा
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-8 border border-gray-300 rounded-lg bg-gray-50">
                    <svg className="w-12 h-12 text-gray-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-gray-600">अद्याप कोणतेही मालक जोडलेले नाहीत</p>
                    <p className="text-sm text-gray-500 mt-1">वरील फॉर्म भरून "मालक जोडा" बटणावर क्लिक करा</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* भोगवाटधारक फॉर्म - Right Side */}
          {showOccupantForm && (
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-lg font-bold text-green-800 flex items-center">
                  <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
                  </svg>
                  भोगवाटधारकांची माहिती
                </h2>
                <button
                  type="button"
                  onClick={closeOccupantForm}
                  className="px-4 py-2 bg-red-500 text-white text-sm font-medium rounded-lg hover:bg-red-600 transition-colors duration-200 flex items-center shadow-sm"
                >
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  बंद करा
                </button>
              </div>
              
              {/* नवीन भोगवाटधारक जोडण्याचा फॉर्म */}
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                <h3 className="text-md font-semibold text-green-800 mb-3 flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                  </svg>
                  नवीन भोगवाटधारक जोडा
                </h3>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      भोगवाटधारकाचे नाव *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={currentOccupantData.name}
                      onChange={handleCurrentOccupantChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="भोगवाटधारकाचे पूर्ण नाव"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      मोबाईल नंबर
                    </label>
                    <input
                      type="text"
                      name="mobileNumber"
                      value={currentOccupantData.mobileNumber}
                      onChange={handleCurrentOccupantChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="मोबाईल नंबर"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      आधार कार्ड नंबर
                    </label>
                    <input
                      type="text"
                      name="aadharNumber"
                      value={currentOccupantData.aadharNumber}
                      onChange={handleCurrentOccupantChange}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                      placeholder="आधार कार्ड नंबर"
                    />
                  </div>
                </div>
                
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    onClick={addOccupant}
                    className="px-4 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center shadow-sm"
                  >
                    <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    भोगवाटधारक जोडा
                  </button>
                </div>
              </div>

              {/* भोगवाटधारकांची सूची - तालिका */}
              <div className="mt-6">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-md font-semibold text-gray-800 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd" />
                    </svg>
                    भोगवाटधारकांची यादी
                  </h3>
                  <div className="text-sm text-gray-600">
                    एकूण भोगवाटधारक: <span className="font-bold">{getFilteredOccupants().length}</span>
                  </div>
                </div>
                
                {getFilteredOccupants().length > 0 ? (
                  <div className="overflow-x-auto border border-gray-300 rounded-lg">
                    <table className="w-full border-collapse text-sm">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            क्रमांक
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            भोगवाटधारकाचे नाव
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            मोबाईल नंबर
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-left text-sm font-medium text-gray-700">
                            आधार कार्ड नंबर
                          </th>
                          <th className="border border-gray-300 px-4 py-3 text-center text-sm font-medium text-gray-700">
                            क्रिया
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getFilteredOccupants().map((occupant, index) => (
                          <tr key={occupant.id} className="hover:bg-gray-50 even:bg-gray-50">
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {index + 1}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm font-medium">
                              {occupant.name}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {occupant.mobileNumber || '-'}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-sm">
                              {occupant.aadharNumber || '-'}
                            </td>
                            <td className="border border-gray-300 px-4 py-3 text-center">
                              <button
                                type="button"
                                onClick={() => removeOccupant(occupant.id)}
                                className="px-3 py-1 bg-red-500 text-white text-xs font-medium rounded hover:bg-red-600 transition-colors duration-200 flex items-center mx-auto"
                              >
                                <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                हटवा
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-8 border border-gray-300 rounded-lg bg-gray-50">
                    <svg className="w-12 h-12 text-gray-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-gray-600">अद्याप कोणतेही भोगवाटधारक जोडलेले नाहीत</p>
                    <p className="text-sm text-gray-500 mt-1">वरील फॉर्म भरून "भोगवाटधारक जोडा" बटणावर क्लिक करा</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* मिळकत सविस्तर माहिती Card */}
        <div className="mt-6">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-lg font-bold mb-4 border-b pb-2">मिळकत सविस्तर माहिती</h2>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Left Side - Form */}
              <div>
                <div className="space-y-4">
                  {/* मिळकत प्रकार */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      मिळकत प्रकार
                    </label>
                    <select
                      name="propertyType"
                      value={propertyDetailData.propertyType}
                      onChange={handlePropertyDetailChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="झोपडी मातीचे घर">झोपडी मातीचे घर</option>
                      <option value="दगड विटा मातीची इमारत">दगड विटा मातीची इमारत</option>
                      <option value="दगड विट सिंमेट घर / लोड बेँअरींग">दगड विट सिंमेट घर / लोड बेँअरींग</option>
                      <option value="आर सी सी इमारत">आर सी सी इमारत</option>
                      <option value="बखळ जागा">बखळ जागा</option>
                    </select>
                  </div>

                  {/* क्षेत्रफळ */}
                  <div>
                    <label className="block text-xs text-gray-600 mb-1">
                      क्षेत्रफळ
                    </label>
                    <div className="grid grid-cols-6 gap-2">
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">लांबी</label>
                        <input
                          type="text"
                          name="length"
                          value={propertyDetailData.length}
                          onChange={handlePropertyDetailChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">रुंदी</label>
                        <input
                          type="text"
                          name="width"
                          value={propertyDetailData.width}
                          onChange={handlePropertyDetailChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">क्षेत्रफळ (स्के.फु)</label>
                        <input
                          type="text"
                          name="area"
                          value={propertyDetailData.area}
                          readOnly
                          className="w-full px-3 py-2 border border-blue-300 rounded-md bg-blue-50 focus:outline-none text-blue-800 font-semibold"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">सुट</label>
                        <input
                          type="text"
                          name="areaDiscount"
                          value={propertyDetailData.areaDiscount}
                          onChange={handlePropertyDetailChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">स्के.मी.</label>
                        <input
                          type="text"
                          name="areaSqKm"
                          value={propertyDetailData.areaSqKm}
                          readOnly
                          className="w-full px-3 py-2 border border-gray-300 rounded-md bg-purple-50 focus:outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-600 mb-1">भांडवली मुल्य</label>
                        <input
                          type="text"
                          name="capitalValue"
                          value={propertyDetailData.capitalValue}
                          readOnly
                          className="w-full px-3 py-2 border border-gray-300 rounded-md bg-purple-50 focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>

                  {/* वापराचा प्रकार */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      वापराचा प्रकार
                    </label>
                    <select
                      name="usageType"
                      value={propertyDetailData.usageType}
                      onChange={handlePropertyDetailChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="निवासी">निवासी</option>
                      <option value="व्यावसायिक">व्यावसायिक</option>
                      <option value="औद्योगिक">औद्योगिक</option>
                      <option value="शेती">शेती</option>
                    </select>
                  </div>

                  {/* बांधकाम दिनांक */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      बांधकाम दिनांक
                    </label>
                    <input
                      type="date"
                      name="constructionDate"
                      value={propertyDetailData.constructionDate}
                      onChange={handlePropertyDetailChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  {/* रेडीरेकनर प्रकार */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      रेडीरेकनर प्रकार
                    </label>
                    <select
                      name="readyReckonerType"
                      value={propertyDetailData.readyReckonerType}
                      onChange={handlePropertyDetailChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="जमिन">जमिन</option>
                      <option value="आर.सी.सी.">आर.सी.सी.</option>
                      <option value="इतर पक्के">इतर पक्के</option>
                      <option value="अर्धे पक्के">अर्धे पक्के</option>
                      <option value="कच्चे">कच्चे</option>
                    </select>
                  </div>

                  {/* विजकर */}
                  <div>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        name="electricityTax"
                        checked={propertyDetailData.electricityTax}
                        onChange={handlePropertyDetailChange}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700 mr-2">विजकर</span>
                      <span className="text-sm text-gray-600 mr-2">सुट</span>
                      <input
                        type="text"
                        name="electricityTaxDiscount"
                        value={propertyDetailData.electricityTaxDiscount}
                        onChange={handlePropertyDetailChange}
                        className="w-20 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </label>
                  </div>

                  {/* आरोग्यकर */}
                  <div>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        name="healthTax"
                        checked={propertyDetailData.healthTax}
                        onChange={handlePropertyDetailChange}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700 mr-2">आरोग्यकर</span>
                      <span className="text-sm text-gray-600 mr-2">सुट</span>
                      <input
                        type="text"
                        name="healthTaxDiscount"
                        value={propertyDetailData.healthTaxDiscount}
                        onChange={handlePropertyDetailChange}
                        className="w-20 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </label>
                  </div>

                  {/* यादित भरणे बटण */}
                  <div>
                    <button
                      type="button"
                      onClick={handleAddPropertyToList}
                      className="px-4 py-2 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition-colors duration-200"
                    >
                      यादित भरणे
                    </button>
                  </div>

                  {/* मिळकत वर्णन चेकबॉक्स */}
                  <div>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        name="propertyDescriptionAsAbove"
                        checked={propertyDetailData.propertyDescriptionAsAbove}
                        onChange={handlePropertyDetailChange}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="text-sm text-gray-700">मिळकत वर्णन वरील प्रमाणे हवे का?</span>
                    </label>
                  </div>

                  {/* मिळकत वर्णन */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      मिळकत वर्णन
                    </label>
                    <textarea
                      name="propertyDescription"
                      value={propertyDetailData.propertyDescription}
                      onChange={handlePropertyDetailChange}
                      rows={4}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="मिळकतीचे वर्णन येथे लिहा..."
                    />
                  </div>
                </div>
              </div>

              {/* Right Side - Records */}
              <div>
                <h3 className="text-md font-semibold mb-4 bg-blue-800 text-white p-2 rounded-t-lg">मिळकत सविस्तर माहिती</h3>
                
                {propertyRecords.length === 0 ? (
                  <div className="text-center py-12 border border-gray-300 rounded-b-lg">
                    <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <p className="text-gray-600 text-lg">No records found</p>
                    <p className="text-sm text-gray-500 mt-2">डावीकडील फॉर्म भरून 'यादित भरणे' बटणावर क्लिक करा</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {propertyRecords.map((record, index) => (
                      <div key={record.id} className="border-2 border-blue-400 rounded-lg overflow-hidden">
                        {/* Header Row */}
                        <div className="bg-blue-800 text-white p-3 grid grid-cols-1 md:grid-cols-6 gap-2 text-sm items-center">
                          <div className="md:col-span-2 font-medium">{record.propertyType}</div>
                          <div className="text-center">{record.area} स्के.फु.</div>
                          <div className="text-center">{record.areaSqKm} स्के.मी.</div>
                          <div className="text-center">वापर {record.usageType}</div>
                          <div className="text-center">वर्ष {new Date(record.constructionDate).getFullYear()}</div>
                          <div className="md:col-span-6 md:text-right mt-1 md:mt-0 text-yellow-300">
                             रेडीरेकनर प्रकार {record.readyReckonerType}
                          </div>
                        </div>

                        {/* Calculations Row */}
                        <div className="bg-blue-700 text-white p-3 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm border-t border-blue-600">
                          <div className="text-center">
                            <span className="block text-xs opacity-80">भांडवली मुल्य</span>
                            <span className="font-bold text-lg">{record.capitalValue}</span>
                          </div>
                          <div className="text-center">
                            <span className="block text-xs opacity-80">घरपट्टी</span>
                            <span className="font-bold text-lg">{record.houseTax || 0}</span>
                          </div>
                          <div className="text-center">
                            <span className="block text-xs opacity-80">विज कर</span>
                            <span className="font-bold text-lg">{record.electricityTaxVal || 50}</span>
                          </div>
                          <div className="text-center">
                            <span className="block text-xs opacity-80">आरोग्य कर</span>
                            <span className="font-bold text-lg">{record.healthTaxVal || 50}</span>
                          </div>
                        </div>

                        {/* Actions Row */}
                        <div className="bg-orange-400 p-2 flex justify-between items-center px-8 text-white">
                          <button 
                            type="button" 
                            className="flex flex-col items-center hover:text-gray-100 transition-colors"
                            onClick={() => alert('बदल करा फंक्शनॅलिटी अद्याप उपलब्ध नाही')}
                          >
                            <svg className="w-5 h-5 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            <span className="text-xs font-medium">बदल</span>
                          </button>

                          <button 
                            type="button" 
                            className="flex flex-col items-center hover:text-gray-100 transition-colors"
                            onClick={() => openDetailModal(record)}
                          >
                            <svg className="w-5 h-5 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            <span className="text-xs font-medium">सविस्तर</span>
                          </button>

                          <button 
                            type="button" 
                            className="flex flex-col items-center hover:text-gray-100 transition-colors"
                            onClick={() => handleDeletePropertyRecord(record.id)}
                          >
                            <svg className="w-5 h-5 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            <span className="text-xs font-medium">खोडणे</span>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center space-x-4 mt-6">
          <button
            type="button"
            onClick={handleBack}
            className="px-6 py-2 bg-gray-500 text-white font-medium rounded-md hover:bg-gray-600 transition-colors duration-200"
          >
            मागे जा
          </button>
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition-colors duration-200"
          >
            जतन करा
          </button>
        </div>
        {/* Detail Modal */}
        {showDetailModal && selectedRecord && (
          <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={closeDetailModal}></div>

              <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

              <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
                <div className="bg-blue-700 px-4 py-3 sm:px-6">
                  <h3 className="text-lg leading-6 font-bold text-white text-center" id="modal-title">
                    वार्षिक मुल्य व कर रक्कम सविस्तर माहिती
                  </h3>
                </div>
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 text-blue-900">
                  <div className="grid grid-cols-2 gap-4 mb-4 border-b border-gray-200 pb-2">
                    <div className="text-lg font-medium">घर प्रकार : <span className="font-bold text-blue-700">{selectedRecord.propertyType}</span></div>
                    <div className="text-right text-lg font-medium">आर्थिक वर्ष : <span className="font-bold">2025 - 2026</span></div>
                  </div>
                  
                  <div className="mb-2 text-md">वार्डचे नाव : <span className="font-bold">{formData.wardName}</span></div>
                  <div className="flex justify-between mb-2 text-md">
                     <div>बांधकाम दिनांक : <span className="font-bold">{new Date(selectedRecord.constructionDate).toLocaleDateString('en-GB')}</span></div>
                     <div>वर्ष संख्या : <span className="font-bold">1</span></div>
                     <div>घसारा दर : <span className="font-bold">1</span></div>
                  </div>
                  <div className="flex justify-between mb-4 text-md">
                     <div>घराचा वापर प्रकार : <span className="font-bold">{selectedRecord.usageType}</span></div>
                     <div>इमारतीचा भारांक : <span className="font-bold">1</span></div>
                     <div>क्षेत्रफळ स्के.फु. : <span className="font-bold">{selectedRecord.area}</span></div>
                  </div>

                  <div className="grid grid-cols-2 gap-x-8 gap-y-2 mb-6 text-md bg-blue-50 p-4 rounded text-blue-800">
                    <div>रेडीरेकनर प्रकार : <span className="font-bold">{selectedRecord.readyReckonerType}</span></div>
                    <div className="text-right">क्षेत्रफळ स्के.मी. : <span className="font-bold">{selectedRecord.areaSqKm}</span></div>
                    
                    <div>वार्षिक मुल्य दर : <span className="font-bold">1760</span></div>
                    <div className="text-right">मुल्य गणना प्रकार : <span className="font-bold">1</span></div>
                    
                    <div>बांधकाम दर : <span className="font-bold">12443</span></div>
                  </div>

                  <div className="bg-gray-50 border border-gray-200 p-4 rounded-md space-y-3 mb-6 font-mono text-sm text-gray-800">
                    <div className="text-xs text-gray-500 mb-1">Calculation Formula</div>
                    <div>
                      <strong>Imartiche Bhandvali Mulya =</strong> [(Area x Land Rate) + (Area x Construction Rate x Depr.) ] x Usage Factor
                    </div>
                    <div>
                      <strong>=</strong> [({selectedRecord.areaSqKm} x 1760) + ({selectedRecord.areaSqKm} x 12443 x 1) ] x 1
                    </div>
                    <div className="text-xl text-blue-900 font-bold mt-2 border-t pt-2">
                      इमारतीचे मुल्य : {selectedRecord.capitalValue}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
                    <div className="bg-blue-50 p-4 rounded">
                      <div className="flex justify-between mb-2">
                        <span>घरासाठी दर :</span>
                        <span className="font-bold">0.6</span>
                      </div>
                      <div className="flex justify-between mb-2">
                        <span>करातुन सुट :</span>
                        <span className="font-bold">0</span>
                      </div>
                      <div className="flex justify-between mt-4 text-xl font-extrabold text-blue-900 border-t border-blue-200 pt-2">
                        <span>घरपट्टी :</span>
                        <span>{selectedRecord.houseTax}</span>
                      </div>
                    </div>

                    <div className="pl-4 border-l-2 border-blue-100 text-sm">
                      <div className="mb-2">
                        <strong>घरपट्टी कर =</strong> (इमारतीचे मुल्य x घर प्रकाराचा दर) / 1000
                      </div>
                      <div className="mb-2">
                        <strong>घरपट्टी कर =</strong> ({selectedRecord.capitalValue} x 0.6) / 1000
                      </div>
                      <div className="mt-2 text-green-700 font-semibold">
                         = {selectedRecord.houseTax}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                  <button 
                    type="button" 
                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={closeDetailModal}
                  >
                    बाहेर
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default Newmilakhatregister;